import {
  getDepositAmounts,
  type DepositTokenSymbol,
} from "../config/constants";

/** Convert a human-readable amount to smallest token units. */
export function amountToSmallestUnits(
  amount: string,
  decimals: number
): bigint {
  return BigInt(Math.round(Number(amount) * 10 ** decimals));
}

/** Convert a pool denomination to smallest token units. */
export function poolAmountToSmallestUnits(
  poolAmount: number,
  decimals: number
): bigint {
  return BigInt(Math.round(poolAmount * 10 ** decimals));
}

/**
 * Split a human-readable amount into supported deposit denominations (greedy, largest first).
 * Throws if the amount cannot be represented exactly.
 */
export function splitAmountIntoDeposits(
  amount: string,
  symbol: DepositTokenSymbol,
  decimals: number
): number[] {
  const poolAmounts = getDepositAmounts(symbol);
  const sorted = [...poolAmounts].sort((a, b) => b - a);

  let remaining = amountToSmallestUnits(amount, decimals);
  const splits: number[] = [];

  for (const denom of sorted) {
    const denomUnits = poolAmountToSmallestUnits(denom, decimals);
    if (denomUnits === 0n) {
      continue;
    }
    while (remaining >= denomUnits) {
      splits.push(denom);
      remaining -= denomUnits;
    }
  }

  if (remaining !== 0n) {
    throw new Error(
      `arcane-privacy-sdk: amount ${amount} cannot be split into supported ${symbol} deposit denominations`
    );
  }

  return splits;
}
